import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useFormik } from 'formik'
import { Upload, Button, Popconfirm, Tooltip, Tag } from 'antd'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import {
  ACL_ACTION_TYPE,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DOCUMENT_TYPE,
  WORK_STATUS,
} from '../../constants'
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineTeam,
  AiOutlineUpload,
  AiOutlineUser,
} from 'react-icons/ai'
import AuthoritiesActionModal from './AuthoritiesActionModal'
import {
  SelectList,
  UploadFileListItem,
  UploadFileListWrapper,
} from './InternalDocumentIncomingDocCreatePageStyled'
import {
  DeleteOutlined,
  FileTextOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import utils from '../../utils'
import { toJS } from 'mobx'
import PopupRenameFile from '../../components/PopupRenameFile/PopupRenameFile'
import * as Yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
import RichEditor from '../../components/RichEditor/RichEditor'
import { ASSIGNEE_TYPE } from '../../utils/constants'
import { AvatarHasName } from '../../components/common/Avatar'
import { MyUploadAdapter } from '../../components/RichEditor/MyUploadAdapter'
import moment from 'moment'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'

const PopupPhanPhatDocumentIncoming = props => {
  const {
    workStore,
    isVisiblePopupPhanPhat,
    handleClosePhanPhatDocument,
    authorityStore,
    bookStore,
    loadingAnimationStore,
    fileStore,
    signedDocumentStore,
    internalDocumentStore,
    createMessage,
    selectPeopleStore,
  } = props
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore
  const {
    getInternalDocumentIncomingById,
    selectedInternalDocumentIncoming,
    getInternalDocumentComment,
    updateInternalDocument,
  } = internalDocumentStore
  const { workTypeList, workList, workDetail } = workStore
  const EDITOR_REF = useRef()
  const { documentId } = useParams()
  const [editorState, setEditorState] = useState(null)
  const [buttonBlock, setButtonBlock] = useState(false)
  const [data, setData] = useState('')
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fileList, setFileList] = useState([])
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])
  const [advanceFilter, setAdvanceFilter] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const [advanceFilterEnd, setAdvanceFilterEnd] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])

  const userList = selectedInternalDocumentIncoming?.assignees
    ? selectedInternalDocumentIncoming?.assignees?.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []
  const departmentList = selectedInternalDocumentIncoming?.assignees
    ? selectedInternalDocumentIncoming?.assignees?.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
      )
    : []
  const groupList = selectedInternalDocumentIncoming?.assignees
    ? selectedInternalDocumentIncoming?.assignees?.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.GROUP
      )
    : []
  useEffect(() => {
    if (editorState) {
      const editor = editorState
      editor.plugins.get('FileRepository').createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader)
      }

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )

      editor.editing.view.change(writer => {
        writer.setStyle(
          'height',
          '200px',
          editor.editing.view.document.getRoot()
        )
      })
    }
  }, [editorState])
  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])
  const assigneesList = selectedInternalDocumentIncoming?.assignees?.filter(
    item => item.permission !== 'CREATE'
  )
  const new_items_assign = []
  const remove_items_assign = []
  const listAssignOrigin = [...userList, ...departmentList, ...groupList].map(
    el => ({
      assignee_code: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
    })
  )
  const listAssignAfter = [...followerList, ...handlerList].map(el => ({
    assignee_code: el.id,
    assignee_type: el.assignee_type,
    permission: el.permission,
  }))
  listAssignAfter.forEach(assignAfter => {
    if (
      !listAssignOrigin.some(
        assignOrigin =>
          assignOrigin.assignee_code + assignOrigin.permission ===
          assignAfter.assignee_code + assignAfter.permission
      )
    ) {
      new_items_assign.push({
        assignee_code: assignAfter.assignee_code,
        assignee_type: assignAfter.assignee_type,
        permission: assignAfter.permission,
      })
    }
  })
  listAssignOrigin.forEach(assignOrigin => {
    if (
      !listAssignAfter.some(
        assignAfter =>
          assignAfter.assignee_code + assignAfter.permission ===
          assignOrigin.assignee_code + assignOrigin.permission
      )
    ) {
      remove_items_assign.push({
        assignee_code: assignOrigin.assignee_code,
        assignee_type: assignOrigin.assignee_type,
        permission: assignOrigin.permission,
      })
    }
  })
  useEffect(() => {
    if (!true) return

    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupList)
      )
    }
  }, [originDepartmentWithUserList])
  const [fileUploadedList, setFileListUpdate] = useState([])
  const fileUploaded = fileUploadedList?.map(item => item.file_id)
  const attachmentsList = selectedInternalDocumentIncoming?.attachments?.map(
    item => item.file_id
  )
  const updateAssignees = useCallback(() => {
    const newAssignees = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    formik.setFieldValue('assignees', newAssignees)
  }, [followerList, handlerList])

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const res = response
      .map(response => response.data.file_id)
      .concat(fileFromDocumentList.map(file => file.file_id))
    let result = res.concat(fileUploaded)
    formik.setFieldValue('attachments', res)
  }, [fileList, fileFromDocumentList])
  useEffect(() => {
    formik.setFieldValue('content', data)
  }, [data])
  useEffect(() => {
    updateAttachments()
    updateAssignees()
  }, [updateAssignees, updateAttachments])

  const navigate = useNavigate()
  const [limit, setLimit] = useState(1)

  useEffect(() => {
    if (new_items_assign?.length > 0) {
      setLimit(formik.values.current_assignees?.length)
    } else if (remove_items_assign.length > 0) {
      setLimit(
        formik.values.current_assignees?.length - remove_items_assign?.length
      )
    }
  }, [handlerList, followerList])
  useEffect(() => {
    setFileListUpdate(selectedInternalDocumentIncoming?.attachments)
  }, [selectedInternalDocumentIncoming])
  useEffect(() => {
    if (selectedInternalDocumentIncoming) {
      const incoming_number =
        selectedInternalDocumentIncoming?.incoming_number || ''
      const title = selectedInternalDocumentIncoming?.title || ''
      const comments_leader = selectedInternalDocumentIncoming?.comments_leader
        ?.lengths
        ? selectedInternalDocumentIncoming?.comments_leader
        : ''
      const leader_name =
        selectedInternalDocumentIncoming?.leader_name &&
        selectedInternalDocumentIncoming?.comments_leader?.length > 0
          ? `Đ/c ${selectedInternalDocumentIncoming?.leader_name}: `
          : ''
      if (selectedInternalDocumentIncoming?.code) {
        formik.setFieldValue('work_type', WORK_STATUS.DOCUMENT)
        formik.setFieldValue(
          'related_documents',
          selectedInternalDocumentIncoming.code &&
            selectedInternalDocumentIncoming.type
            ? [
                {
                  code: selectedInternalDocumentIncoming.code,
                  type: selectedInternalDocumentIncoming.type,
                },
              ]
            : []
        )
        formik.setFieldValue(
          'title',
          `Xử lý văn bản ${
            incoming_number ? 'đến ' + incoming_number : 'đi'
          }: ${title}`
        )
        formik.setFieldValue(
          'content',
          `Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`
        )
        formik.setFieldValue('start_date', moment())
        const files = selectedInternalDocumentIncoming?.attachments?.map(
          file => ({
            file_id: file.id,
            file_name: file.name,
          })
        )
        setFileFromDocumentList(files)
      }
      if (selectedInternalDocumentIncoming?.mission_code) {
        formik.setFieldValue('work_type', WORK_STATUS.DEPLOY)
      }
      if (!formik.values.work_type) {
        formik.setFieldValue('work_type', WORK_STATUS.OTHER)
      }
    }
  }, [selectedInternalDocumentIncoming])
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: '',
      start_date: '',
      related_documents: [],
      related_tasks: [],
      due_date: null,
      content: '',
      attachments: '',
      assignees: [],
      parent_id: null,
      work_type: '',
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required('Vui lòng nhập tiêu đề !')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập tiêu đề !'),
      start_date: Yup.string().required('Vui lòng chọn ngày bắt đầu !'),
      assignees: Yup.array().min(1, 'Vui lòng chọn người xử lý !'),
    }),
    onSubmit: async values => {
      setButtonBlock(true)
      try {
        loadingAnimationStore.showSpinner(true)
        await workStore.createWork(values)
        await getInternalDocumentIncomingById(documentId)
        loadingAnimationStore.showSpinner(false)
        createMessage('Tạo công việc thành công!', true, 'success')
      } catch (err) {
        // console.log(err);
      } finally {
        handleClosePhanPhatDocument()
        setButtonBlock(false)
        setFileList([])
        setFollowerList([])
        setHandlerList([])
        selectPeopleStore.clearSelectPeopleStore([])
      }
    },
  })
  const handleChangeStart = value => {
    if (advanceFilterEnd.month !== null) {
      if (moment(advanceFilterEnd.month.$d).isSameOrAfter(moment(value.$d))) {
        setAdvanceFilter({
          ...advanceFilter,
          month: value,
        })
        formik.setFieldValue('start_date', value)
      } else {
        createMessage(
          'ngày bắt đầu không thể muộn hơn ngày kết thúc, xin vui lòng chọn lại !!!',
          true,
          'error'
        )
      }
    } else {
      setAdvanceFilter({
        ...advanceFilter,
        month: value,
      })
      formik.setFieldValue('start_date', value)
    }
  }
  const handleChangeEnd = value => {
    if (moment(value.$d).isSameOrAfter(moment(advanceFilter.month.$d))) {
      setAdvanceFilterEnd({
        ...advanceFilterEnd,
        month: value,
      })
      formik.setFieldValue('due_date', value)
    } else {
      createMessage(
        'ngày kết thúc không thể sớm hơn ngày bắt đầu, xin vui lòng chọn lại !!!',
        true,
        'error'
      )
    }
  }
  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }
  const handleFileChange = useCallback(async info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])
  const handleRemoveFileFromDocumentList = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentList(newFileList)
  }
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }
  const submitRenameFile = async value => {
    const index = fileTargetRename?.index
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      // message.success('Đổi tên file thành công')
      createMessage('Đổi tên file thành công', true, 'success')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      setIsModalVisibleRenameFile(false)
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      setFileList(newFileList)
      createMessage('Đổi tên file thành công', true, 'success')
    }
  }

  return (
    <Dialog
      open={isVisiblePopupPhanPhat}
      onClose={handleClosePhanPhatDocument}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw',
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">Phân phát văn bản</span>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: 12, marginTop: 8 }}>
            <InputLabel>
              <>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun,sans-serif',
                    lineHeight: 1,
                  }}>
                  *
                </span>
                <span> Loại công việc</span>
              </>
            </InputLabel>
            <Select
              name="work_type"
              sx={{ width: '100%' }}
              defaultValue={workTypeList[0]?.id}
              onChange={formik.handleChange}
              label="Cơ quan ban hành">
              {workTypeList.map(wTypeList => (
                <MenuItem key={wTypeList.id} value={wTypeList.id}>
                  {wTypeList.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <TextField
              name="title"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Tiêu đề</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: 'center', height: '56px', width: '100%' }}
              onChange={e => {
                formik.handleChange(e)
              }}
              value={formik.values?.title}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Nội dung:
            </InputLabel>
            <RichEditor
              EDITOR_REF={EDITOR_REF}
              editorContent={formik.values.content}
              setData={setData}
              placeholder={'Nhập nội dung...'}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="start_date"
                label={
                  <>
                    <span
                      style={{
                        display: 'inline-block',
                        color: '#ff4d4f',
                        fontSize: '14px',
                        fontFamily: 'SimSun,sans-serif',
                        lineHeight: 1,
                      }}>
                      *
                    </span>
                    <span> Ngày bắt đầu</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={formik.values.start_date || advanceFilter.month}
                onChange={handleChangeStart}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_date && formik.touched.start_date
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginBottom: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="due_date"
                openTo="day"
                label={
                  <>
                    <span> Ngày kết thúc</span>
                  </>
                }
                // views={["day", "month", "year"]}
                value={advanceFilterEnd.month}
                onChange={handleChangeEnd}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    helperText={null}
                    error={false}
                    placeholder="-- Chọn ngày kết thúc --"
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <Box
            sx={{
              margin: '10px 0',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              onChange={handleFileChange}
              beforeUpload={() => false}
              showUploadList={false}>
              <Button
                variant="contained"
                className="gap-1 flex items-center justify-center bg-[#1976d2] py-[20px]">
                <AiOutlineUpload />
                Chọn tài liệu đính kèm
              </Button>
            </Upload>
          </Box>
          {fileFromDocumentList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileFromDocumentList.map(file => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.file_id}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span
                      onClick={() =>
                        fileStore.handleDownloadFile(
                          file.file_id,
                          file.file_name
                        )
                      }
                      style={{ color: '#1890FF' }}>
                      {file.file_name}
                    </span>
                  </div>
                  <AiOutlineDelete
                    className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                    onClick={() =>
                      handleRemoveFileFromDocumentList(file.file_id)
                    }
                  />
                </li>
              ))}
            </ul>
          )}
          {fileList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileList.map((file, index) => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.uid}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                  </div>
                  <div className="flex items-center">
                    <Button
                      className="text-[#1890FF]"
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        setIsRenameFileUpdate(true)
                        handleOpenPopupRenameFile(file, index)
                      }}>
                      Đổi tên
                    </Button>
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() => handleRemoveFileFromUploadList(file.uid)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span> Người xử lý:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {handlerList.map(el => (
                  <SelectList>
                    <Tag
                      name="assignees"
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          {formik.errors.assignees && formik.touched.assignees && (
            <p style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}>
              {formik.errors.assignees || formik.touched.assignees}
            </p>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Người theo dõi:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {followerList.map(el => (
                  <SelectList>
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: '0' }}>
          <Button
            type="button"
            sx={{ fontWeight: 600 }}
            onClick={handleClosePhanPhatDocument}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            Đóng
          </Button>
          {buttonBlock ? (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Phân phát
            </button>
          ) : (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Phân phát
            </button>
          )}
        </DialogActions>
      </form>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />

      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  )
}

export default memo(
  inject(
    'authorityStore',
    'bookStore',
    'loadingAnimationStore',
    'commonStore',
    'fileStore',
    'signedDocumentStore',
    'internalDocumentStore',
    'selectPeopleStore',
    'workStore'
  )(observer(PopupPhanPhatDocumentIncoming))
)
